<script>
  import Dropdown from '@leaflink/stash/Dropdown.vue';
  import Icon from '@leaflink/stash/Icon.vue';
  import Menu from '@leaflink/stash/Menu.vue';
  import MenuItem from '@leaflink/stash/MenuItem.vue';

  import api from '@/services/api';
  import { track } from '@/track';
  import { normalizeLocale } from '@/utils/i18n';

  export default {
    name: 'LanguagePicker',

    components: {
      Dropdown,
      Icon,
      Menu,
      MenuItem,
    },

    props: {
      language: {
        type: String,
        required: true,
      },
      languages: {
        type: Array,
        required: true,
      },
    },

    data() {
      return {
        isOpen: false,
      };
    },

    computed: {
      languageOptions() {
        return this.languages.map((lang) => ({
          code: normalizeLocale(lang[0]),
          name: lang[1],
        }));
      },
    },

    methods: {
      handleToggle(isOpen) {
        this.isOpen = isOpen;
      },

      async setLang(newLang) {
        if (newLang === this.language) {
          return;
        }

        const previousLanguage = this.language.toLowerCase();
        const selectedLanguage = newLang.toLowerCase();

        const payload = {
          selectedLanguage,
        };

        await api.user.updateLanguage(payload);

        track('Language Changed', {
          previous_language: previousLanguage,
          selected_language: selectedLanguage,
        });

        window.location.reload();
      },
    },
  };
</script>

<template>
  <Dropdown :class="$style.wrapper" content-class="language-picker__content" :reattach="false" @toggle="handleToggle">
    <template #toggle="{ toggle }">
      <button
        data-test="toggle|language"
        type="button"
        :aria-expanded="isOpen.toString()"
        :class="[{ 'is-active': isOpen }, $style.toggle]"
        @click="toggle"
      >
        <Icon name="globe" :class="$style.icon" />
      </button>
    </template>

    <template #default>
      <Menu data-test="language-picker__list">
        <MenuItem v-for="(option, i) in languageOptions" :class="{ 'is-active': option.code === language }" :key="i">
          <button :data-test="`button|language-${option.code.toLowerCase()}`" @click="setLang(option.code)">
            {{ option.name }}
          </button>
        </MenuItem>
      </Menu>
    </template>
  </Dropdown>
</template>

<style lang="scss" module>
  .wrapper {
    :global(.language-picker__content) {
      &::after {
        background: var(--color-white);
      }
    }

    :global(.stash-menu-item.is-active) button {
      color: var(--color-blue);
    }

    :global(.stash-menu-item:hover) button {
      color: var(--color-ice-700);
    }

    .icon {
      height: icon('default', 'height');
      width: icon('default', 'width');
    }
  }

  .toggle {
    outline: 0;
    padding: 0;

    &:hover .icon,
    &:focus .icon {
      color: var(--color-blue);
    }
  }
</style>
